'use client'

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDown, Plus } from 'lucide-react'
import React from 'react'

type Project = { id: number; nom: string }

type Props = {
  projects: Project[]
  selectedProject: Project | null
  onSelect: (p: Project) => void
  onCreateClick: () => void
}

export default function ProjectSelector({
  projects,
  selectedProject,
  onSelect,
  onCreateClick
}: Props) {
  return (
    <Menu as="div" className="relative">
      <MenuButton className="flex items-center px-2 py-1.5 bg-gray-100 rounded-md hover:bg-gray-200 transition focus:outline-none border border-gray-200">
        <span className="text-base font-medium text-gray-800 truncate max-w-[120px]">
          {selectedProject ? selectedProject.nom : 'Choisir un projet'}
        </span>
        <ChevronDown className="ml-1 w-4 h-4 text-gray-500" />
      </MenuButton>
      <MenuItems className="absolute left-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10 focus:outline-none py-1 animate-fade-in max-h-64 overflow-y-auto">
        <MenuItem>
            <button
                onClick={() => onSelect({ id: 0, nom: 'Tous' })}
                className={`w-full text-left px-3 py-2 text-sm rounded transition ${
                selectedProject?.id === 0
                    ? 'bg-blue-50 text-blue-700 font-semibold'
                    : 'text-gray-700'
                } ui-active:bg-gray-100 ui-active:text-gray-900`}
            >
                Tous les projets
            </button>
        </MenuItem>
        {[...projects].sort((a, b) => a.nom.localeCompare(b.nom)).map((p) => (
          <MenuItem key={p.nom}>
            <button
                onClick={() => onSelect(p)}
                className="w-full text-left px-3 py-2 text-sm rounded transition ui-active:bg-gray-100 ui-active:text-gray-900 text-gray-700"
            >
                {p.nom}
            </button>
            </MenuItem>
        ))}
        <div className="border-t my-1" />
            <MenuItem>
                <button
                    onClick={onCreateClick}
                    className="w-full text-left px-3 py-2 text-sm flex items-center rounded text-blue-600 ui-active:bg-blue-50 ui-active:text-blue-700"
                >
                    <Plus className="w-4 h-4 mr-2" /> Créer un projet
                </button>
            </MenuItem>
        </MenuItems>
    </Menu>
  )
}
